import Plus from '../src/Plus';
export default Plus;
